import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Subject } from 'rxjs';
import { BannersService } from '../../services/banners.service';
import { UserService } from '../../services/user.service';
import { AccountsService } from '../../services/accounts.service';
import { customerAccountsService } from '../../services/customeraccounts.service ';
import * as papa from 'papaparse';
import { Router } from '@angular/router';

@Component({
    selector: 'app-customeraccount',
    templateUrl: './customeraccounts.component.html',
    styleUrls: ['./customeraccounts.component.css']
})
export class customerAccountsComponent implements OnInit {
    customerAccountList: any[] = [];
    imgURL: any;
    viewBanner: any;
    snackBarDimension: any = {
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        duration: 5000,
    };
    imageChangedEvent: any;
    fileToReturn: File;
    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject<any>();
    collection: Array<any> = [];
    dataList: any[];
    bulkUpdate: boolean = false;
    constructor(public customerAccountService: customerAccountsService, public userService: UserService, public modalService: NgbModal,
        public _snackBar: MatSnackBar, private route: Router) {
        console.log(this.userService.rolesArrayPermission);
    }

    ngOnInit(): void {
        this.dtTrigger.next();
        this.getCustomerAccountList();
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10
        };
    }

    getCustomerAccountList() {
        this.customerAccountService.getcustomerAccountsList().subscribe((result: any) => {
            console.log(result);
            this.customerAccountList = result;
            if (!this.bulkUpdate) {
                this.dtTrigger.next();
            }
        })
    }

    viewCustomerAccountDetails(viewB, id) {
        this.imgURL = null;
        this.fileToReturn = null;
        this.customerAccountService.getcustomerAccounts(id).subscribe(result => {
            this.viewBanner = result;
            console.log(result);
            if (this.viewBanner && this.viewBanner.asset && this.viewBanner.asset.asset_expiring_url) {
                this.imgURL = this.viewBanner.asset.asset_expiring_url;
            }
            this.modalService.open(viewB, { ariaLabelledBy: 'modal-basic-title', size: 'lg', scrollable: true }).result.then((result) => {
            }, (reason) => {
            });
        }), error => {
            this._snackBar.open('Can not get customer account details', 'Ok', this.snackBarDimension);
        }
    }

    onFileSelect(event: any, emp): void {
        if (event && event.target.files.length > 0) {
            this.imageChangedEvent = event;
            this.modalService.open(emp, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
                // this.closeResult = `Closed with: ${result}`;
            }, (reason) => {
                //  this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            });
        }
    }

    base64ToFile(data, filename) {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = window.atob(arr[1]);
        let n = bstr.length;
        // let u8arr = new Uint8Array(n);
        let u8arr = new Uint8Array(new ArrayBuffer(n));
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    imageCropped(event: ImageCroppedEvent) {
        console.log(event);
        if (event.base64) {
            this.fileToReturn = this.base64ToFile(
                event.base64,
                this.imageChangedEvent.target.files[0].name,
            );
            if (this.fileToReturn) {
                const file = this.fileToReturn;
                const reader = new FileReader();
                reader.readAsDataURL(this.fileToReturn);
                reader.onload = (_event) => {
                    this.imgURL = reader.result;
                };
            }
        }
    }

    imageLoaded(event) {
    }
    cropperReady(event) {
    }
    loadImageFailed(event) {
        this.imgURL = this.imgURL;
    }
    resetSelectedImage(element?) {
        this.fileToReturn = null;
        if (this.viewBanner.asset.asset_expiring_url) {
            this.imgURL = this.viewBanner.asset.asset_expiring_url;
        } else {
            this.imgURL = '';
        }
    }



    closeModal = () => {
        this.collection = [];
        this.modalService.dismissAll();
        if (this.bulkUpdate) {
            this.getCustomerAccountList();
        }
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    viewcustomerAccountsCSVmodel(viewCustomerAccountsCSV) {
        this.collection = [];
        this.modalService.open(viewCustomerAccountsCSV, {
            ariaLabelledBy: 'modal-basic-title', size: 'xl',
            scrollable: true
        }).result.then((result) => {

        }, (reason) => {

        });
    }

    fileChangeListenera(files: File[]) {
        this.collection = [];
        if (files[0]) {
            console.log(files[0]);
            papa.parse(files[0], {
                header: true,
                skipEmptylines: true,
                complete: (result, file) => {
                    console.log(result);
                    this.dataList = result.data;

                    for (let x = 0; x < this.dataList.length - 1; x++) {
                        console.log(this.dataList);
                        let customerAccountObj = {
                            customer_account: {
                                number: this.dataList[x].account_number,
                                customer_id: this.dataList[x].customer_id,
                                account_id: this.dataList[x].account_type_id,
                                opening_date: this.dataList[x].opening_date,
                                closing_date: this.dataList[x].closing_date,
                                description: this.dataList[x].description,
                                branch_id: this.dataList[x].branch_id,
                                status: this.dataList[x].status
                            }

                        };
                        //  this.callSaveMethod(customerObj);
                        this.collection.push(customerAccountObj);
                        console.log(this.collection);

                    }

                }
            })
        }
    }

    uploadRowData() {
        for (let i = 0; i <= this.collection.length - 1; i++) {
            this.callSaveMethod(this.collection[i]);
        }
    }


    callSaveMethod(customerAccountObj) {
        try {
            var customerAccountId = customerAccountObj.customer_account.number;
            var index = this.collection.findIndex(item => item.customer_account.number == customerAccountId)
            this.customerAccountService.bulkCreatecustomerAccount(customerAccountObj).subscribe(async result => {
                if (result) {
                    var index = this.collection.findIndex(item => item.customer_account.number == customerAccountId)
                    this.collection[index].customer_account.response = "completed";
                    this.bulkUpdate = true;
                }
            }, async error => {
                this.bulkUpdate = false;
                if (error) {
                    var stringMessage = JSON.stringify(error.error);
                    var temp = stringMessage.split(":");
                    var message = JSON.parse(temp[1].replace("}", " ")).toString();
                    this.collection[index].customer_account.error = message;
                    return;
                }
                else {
                    this.collection[index].customer_account_balance.error = "Failed to update";
                    return;
                }
            });
        } catch (e) {
            console.log(e);
            this.bulkUpdate = false;
        }
    }
}
